/*global define, Element */

(function (ELEMENT) {
    ELEMENT.matches = ELEMENT.matches || ELEMENT.mozMatchesSelector || ELEMENT.msMatchesSelector || ELEMENT.oMatchesSelector || ELEMENT.webkitMatchesSelector;

    ELEMENT.closest = ELEMENT.closest || function closest(selector) {
        var element = this;

        while (element) {
            if (element.matches(selector)) {
                break;
            }

            element = element.parentElement;
        }

        return element;
    };
}(Element.prototype));

(function (factory) {
    if (typeof define === "function" && define.amd) {
        define(function () {
            return factory();
        });
    } else {
        window.FehuForms = factory();
    }
}(function () {
    var Events = [];
    var Fehu = {
        events: {
            beforeInitForm: "beforeInitForm",
            afterInitForm: "afterInitForm",
            beforeDialChange: "beforeDialChange",
            afterDialChange: "afterDialChange",
            beforeToggle: "beforeToggle",
            afterToggle: "afterToggle",
            beforeCallback: "beforeCallback",
            afterCallback: "afterCallback"
        },
        forms: [],
        pairSelector: null
    };
    Fehu.on = function (name, callback) {
        if (typeof Events[name] === "undefined") {
            Events[name] = [];
        }
        Events[name].push({
            name: name,
            callback: callback
        });
    };
    Fehu.off = function (name, callback) {
        if (typeof Events[name] === "undefined") {
            Events[name] = [];
        }
        for (var e = 0; e < Events[name].length; ++e) {
            var event = Events[name][e];
            if (event.callback === callback) {
                Events[name].splice(e, 1);
            }
        }
    };
    Fehu.trigger = function (name, event) {
        if (typeof Events[name] === "undefined") {
            Events[name] = [];
        }
        for (var e = 0; e < Events[name].length; ++e) {
            var handler = Events[name][e];
            handler.callback(event);
        }
    };
    Fehu.findAndInit = function () {
        this.forms = document.getElementsByTagName("form");
        for (var f = 0; f < this.forms.length; ++f) {
            var form = this.forms[f];
            form.pairSelector = form.getAttribute("data-pair-selector") || this.pairSelector;
            this.initForm(form);
        }
    };
    Fehu.initForm = function (form) {
        var event = {
            form: form,
            isValid: true
        };
        this.trigger(this.events.beforeInitForm, event);
        if (event.isValid === false) return false;
        for (var c = 0; c < form.elements.length; ++c) {
            var element = form.elements[c],
                events = JSON.parse(element.getAttribute("data-events")) || [];
            if (events.indexOf("toggle") !== -1) {
                element.onchange = this.onToggle;
                element.onchange();
            }
            if (events.indexOf("dialChange") !== -1) {
                element.onchange = this.onDialChange;
                element.onchange();
            }
            if (events.indexOf("callback") !== -1) {
                element.onchange = this.onCallback;
                element.onchange();
            }
        }
        this.trigger(this.events.afterInitForm, event);
    };
    Fehu.onToggle = function (event) {
        var element = (event && event.target) || this,
            form = element.form,
            useDisabled = element.getAttribute("data-use-disabled") === "true",
            eventBA = {
                element: element,
                isValid: true
            };
        Fehu.trigger(Fehu.events.beforeToggle, eventBA);
        if (eventBA.isValid === false) return false;
        for (var e = 0; e < form.elements.length; ++e) {
            var control = form.elements[e],
                allowed = true;
            Fehu.trigger(Fehu.events.beforeToggle, {"element": control});
            if (JSON.parse(control.getAttribute("data-toggle-by")) !== element.name) {
                continue;
            }
            if (element.type === "checkbox") {
                allowed = element.checked;
            } else {
                var definitions = JSON.parse(control.getAttribute("data-toggle-allowed")) || [];
                if (definitions.indexOf(element.value) !== -1) {
                    allowed = true;
                } else {
                    allowed = false;
                }
            }
            Fehu.show(control, allowed, useDisabled);
            Fehu.trigger(Fehu.events.afterToggle, {"element": control});
        }
        Fehu.trigger(Fehu.events.afterToggle, eventBA);
    };
    Fehu.onDialChange = function (event) {
        var element = (event && event.target) || this,
            form = element.form,
            selectedItem = element.value,
            eventBA = {
                element: element,
                isValid: true
            };
        Fehu.trigger(Fehu.events.beforeDialChange, eventBA);
        if (eventBA.isValid === false) return false;
        for (var e = 0; e < form.elements.length; ++e) {
            var control = form.elements[e];
            Fehu.trigger(Fehu.events.beforeDialChange, {"element": control});
            if (JSON.parse(control.getAttribute("data-dial-by")) !== element.name) {
                continue;
            }
            var dials = JSON.parse(control.getAttribute("data-dial-items"));
            var selectedDial = dials[selectedItem];
            Fehu.changeDial(control, selectedDial);
            Fehu.trigger(Fehu.events.afterDialChange, {"element": control});
        }
        Fehu.trigger(Fehu.events.afterDialChange, eventBA);
    };
    Fehu.onCallback = function (event) {
        var element = (event && event.target) || this,
            form = element.form,
            eventBA = {
                element: element,
                isValid: true
            };
        Fehu.trigger(Fehu.events.beforeCallback, eventBA);
        if (eventBA.isValid === false) return false;
        var callback = element.getAttribute("data-callback") || "";
        var F = new Function(callback);
        F(element, form);
        Fehu.trigger(Fehu.events.afterCallback, eventBA);
    };
    Fehu.show = function (element, show, useDisabled) {
        if (typeof show === "undefined") show = true;
        if (typeof useDisabled === "undefined") useDisabled = true;
        var form = element.form;
        var display = show ? "" : "none";
        if (form.pairSelector !== null && form.pairSelector !== "") {
            var closest = element.closest(form.pairSelector);
            if (closest instanceof Element) {
                closest.style.display = display;
            }
        } else {
            element.style.display = display;
        }
        if (useDisabled) {
            element.disabled = !show;
        }
    };
    Fehu.hide = function (element) {
        Fehu.show(element, false);
    };
    Fehu.changeDial = function (element, dial) {
        var selectedKey = element.value;
        while (element.options.length > 0) {
            element.remove(0);
        }
        for (var key in dial) {
            var option = document.createElement("option");
            option.value = key;
            option.text = dial[key];
            if (key === selectedKey) option.selected = true;
            element.add(option, null);
        }
    };
    return Fehu;
}));